import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { LiveReserveContext } from '../../LiveLessonReseveContext';
import Modal from '../../../../../common/Modal';
import LiveReserveSituationModal from './modal/LiveReserveSituationModal';

import {
  LiveReserveSituationDisplaySituations,
  LiveReserveSituationValue,
  LiveReserveSituationItem,
} from '../../../../../../models/lesson/live/reserve/situation/LiveReserveSituation';


function LiveReserveSituation() {

  const { isPc } = useContext(cmnContext);
  const {
    displaySituations, selectedSituation,
  } = useContext(LiveReserveContext);

  const [dispSitucation, setDispSituation] = useState<string>('');
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);


  // 選択時にモーダルを閉じる
  useEffect(() => {
    setIsDispModal(false);
  }, [selectedSituation])


  // 実践内容
  useEffect(() => {
    if (!displaySituations) return;
    for (const situation of displaySituations as LiveReserveSituationDisplaySituations) {
      const valueMap: LiveReserveSituationValue = situation.value;
      for (const key in valueMap) {
        const category: LiveReserveSituationItem = valueMap[key];
        if (category.id === selectedSituation) {
          setDispSituation(category.situation);
        }
      }
    }
  }, [displaySituations, selectedSituation]);


  return (
    <>
      {/* ★SPEAKOUT-1853 空き枠が無くても隠さない。希望日時のリクエストでも
          「実践したい内容」は必須で、事務局へのメール本文にも入れる。 */}
      <>
        {/* ★id は「予約する」が押せないときのスクロール先（LiveReserveSubmit が使う） */}
        <div
          id="live_reserve_situation"
          style={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '15px',
        }}>

          <div>
            <label className="control-label" htmlFor="contact-birth" style={{
              backgroundColor: '#eaffea',
              padding: '0.25em 3em 0.25em 0.5em',
              borderLeft: 'solid 5px #3c8c3c',
            }}>実践したい内容</label>

            <div style={{marginLeft: '5px'}}>
              <p style={{
                margin: 0,
                fontSize: '16px',
                // バリデーションStyle
                ...(!selectedSituation ? 
                  {
                    backgroundColor: 'red',
                    color: '#fff',
                    padding: '3px 10px',
                  }
                  : {}
                )
              }}>
                {(dispSitucation) ?
                  <>{dispSitucation}</>
                :
                  <>内容を選んでください</>
                }
              </p>
            </div>
          </div>

          <div style={{marginRight: isPc? '5px':0}}>
            <button
              type="button"
              className='btn btn-success'
              style={{
                width: '100%',
                margin: isPc? '10px 0 0 5px' : '5px 0 0 5px',
              }}
              onClick={() => setIsDispModal(true)}
            >
              {(selectedSituation)? '選び直す' : '内容を選ぶ' }
            </button>
          </div>

        </div>

        {/* 選択モーダル */}
        <Modal
          comp={<LiveReserveSituationModal />}
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          isDispClose={true}
        />
      </>
    </>
  );
}
  
export default LiveReserveSituation;